<template>
  <div>
    <!-- <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div class="alert-icon">
        <i class="fas fa-info text-primary"></i>
      </div>
      <div class="alert-text">
        Selectionner un <strong>Devis</strong> pour voir le detail.
      </div>
    </div> -->
    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <b-overlay :show="isLoading" rounded="sm">
          <!--begin::Base Table Widget 7-->
          <div class="card card-custom card-stretch gutter-b">
            <!--begin::Header-->
            <div class="card-header border-0 mt-5">
              <h3 class="card-title align-items-start flex-column text-dark">
                <span class="font-weight-bolder text-dark"
                  >Liste des parrainages</span
                >
              </h3>
              <div class="card-toolbar"></div>
            </div>
            <!--end::Header-->
            <!--begin::Body-->
            <div class="card-body py-0 mt-n3">
              <!--begin::Table-->
              <DxDataGrid
                @initialized="saveGridInstance"
                :data-source="dataSource"
                :remote-operations="false"
                :columns="columns"
                :show-row-lines="true"
                :word-wrap-enabled="true"
                :show-borders="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :row-alternation-enabled="false"
                :hover-state-enabled="true"
                :column-auto-width="true"
                :show-column-lines="true"
                :selection="{ mode: 'none' }"
                @row-click="onRowClick"
              >
                >
                <DxFilterRow :visible="true" />

                <DxHeaderFilter :visible="true" :allow-search="true" />
                <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
                <DxPager
                  :show-page-size-selector="true"
                  :allowed-page-sizes="[5, 10, 20]"
                />
                <DxGroupPanel :visible="true" />
                <DxGrouping :auto-expand-all="true" />
                <DxPaging :page-size="10" />
                <DxSearchPanel :visible="true" />
                <DxSummary>
                  <DxTotalItem
                    column="dateUtc"
                    summary-type="count"
                    display-format="{0}"
                  />
                </DxSummary>
              </DxDataGrid>
              <br />
              <!--end::Table-->
            </div>
            <!--end::Body-->
          </div>
          <!--end::Base Table Widget 7-->
        </b-overlay>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";

import RequestsService from "../../../services/requests.service";
import { SET_QUOTES_COUNT } from "../../../core/services/store/notification.module";

export default {
  name: "request-quotes",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      isLoading: false,
      dataSource: {},
      columns: [
        {
          dataField: "createdAtUtc",
          caption: "Date de commande",
          dataType: "datetime",
          sortOrder: "desc",
          // calculateCellValue: (rowData) => {
          //   return FctsHelper.convertUTCDateToLocalDate(rowData.dateUtc);
          // },
        },
        { dataField: "reference", caption: "Réference", dataType: "string" },
        { dataField: "service.name", caption: "Service", dataType: "string" },
        { dataField: "subService.name", caption: "Pack", dataType: "string" }, 
        {
          dataField: "subscriptionType.label",
          caption: "Type",
        },      
        {
          dataField: "referrer.userName",
          caption: "Parrain",
          dataType: "string",
        },
        {
          dataField: "referrer.referralCode",
          caption: "Code parrainage",
          dataType: "string",
        },
        {
          dataField: "subscriptionState.label",
          caption: "Etat",
        },
      
        {
          dataField: "endDateUtc",
          caption: "Fin d'abonnement",
          dataType: "datetime",
          // calculateCellValue: (rowData) => {
          //   return FctsHelper.convertUTCDateToLocalDate(rowData.dateUtc);
          // },
        },  
        {
          dataField: "amount",
          caption: "Montant",
          format: {
            type: "fixedPoint",
            precision: 2,
          },
        },
        // { dataField: "stateLabel", caption: "Etat" },
      ],
      requestCount: {},
    };
  },
  created() {
    this.$availabilityHub.$on("request-notify", this.refresh);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("request-notify", this.refresh);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Abonnements", route: "referrals" },
      { title: "Parrainages" },
    ]);

    // this.dataSource = createStore({
    //   key: "guid",
    //   loadUrl: `${ApiService.baseURL}coordinator/v1/requests/quotes`,
    //   onBeforeSend: DxHelper.onBeforeSend,
    //   onAjaxError: DxHelper.onAjaxError,
    // });

    this.getQuotes();
  },
  methods: {
    getQuotes: function () {
      this.isLoading = true;
      RequestsService.getQuotes().then((result) => {
        this.dataSource = result.data;
        this.$store.dispatch(SET_QUOTES_COUNT, result.data.length);
        this.isLoading = false;
      });
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onRowClick(e) {
      if (e.rowType === "data") {
        // this.$router.push({
        //   name: "requests-detail",
        //   params: { guid: e.data.guid },
        // });
      }
    },
    refresh() {
      this.getQuotes();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
